import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Unhandled error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.hasError) {
      const errMsg = this.state.error?.message || String(this.state.error);
      const stack = this.state.errorInfo?.componentStack || this.state.error?.stack || "";
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: "100vh",
            background: "#0B1622",
            color: "#E2E8F0",
            padding: "32px",
            fontFamily: "system-ui, -apple-system, sans-serif",
            overflow: "auto",
          }}
        >
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            <h1 style={{ color: "#00D4FF", fontSize: "28px", marginBottom: "16px" }}>
              Ha ocurrido un error inesperado
            </h1>
            <p style={{ color: "#94A3B8", marginBottom: "24px" }}>
              La pagina ha tenido un problema. Puedes volver al dashboard o recargar.
            </p>
            <div
              style={{
                background: "#1A2332",
                border: "1px solid #334155",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "24px",
                fontFamily: "Menlo, monospace",
                fontSize: "13px",
                color: "#F87171",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight: "400px",
                overflow: "auto",
              }}
            >
              <strong>Error:</strong> {errMsg}
              {stack ? `\n\nStack:\n${stack}` : ""}
            </div>
            <div style={{ display: "flex", gap: "12px" }}>
              <button
                data-testid="error-reset-btn"
                onClick={this.handleReset}
                style={{
                  background: "#00D4FF",
                  color: "#0B1622",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Volver al dashboard
              </button>
              <button
                data-testid="error-reload-btn"
                onClick={() => window.location.reload()}
                style={{
                  background: "transparent",
                  color: "#E2E8F0",
                  padding: "10px 20px",
                  border: "1px solid #334155",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Recargar pagina
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
